export const FREQUENT_QUESTIONS_VIEW_NAME = 'Preguntas frecuentes';
export const TERMS_AND_CONDITIONS_VIEW_NAME = 'Términos y condiciones';
export const LEGAL_NOTICES_VIEW_NAME = 'Avisos legales';
export const CONTACT_US_VIEW_NAME = 'Contáctanos';
export const DATA_PRIVACY_TERMS_VIEW_NAME = 'Términos de tratamiento de data personal';
export const SERVICE_TRACKING = 'Seguimiento';
